import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const roleGridColumns: GridColumnConfig[] = [
  {
    title: 'Username',
    field: 'fullName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'User Role',
    field: 'roleName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'User Email',
    field: 'email',
    filter: 'text',
    searchable: true,
  },
];
